import { css, type SerializedStyles } from '@emotion/react';
import type { CSSProperties } from 'react';

import { SETTINGS_COLORS, SETTINGS_SCRIM_COLOR, SETTINGS_SPACING, SETTINGS_TITLE_REGULAR_STYLE } from '@/Client/Styles';
import { pxToRem } from '@/Client/Styles/pxToRem';

export type SuperAdminModalStyles = {
  overlay: SerializedStyles;
  content: SerializedStyles;
  header: SerializedStyles;
  title: SerializedStyles;
  body: SerializedStyles;
  // CommonActionButton is Emotion-free: it takes overrides as style objects, not css.
  closeButton: CSSProperties;
};

export const DEFAULT_SUPER_ADMIN_MODAL_STYLES: SuperAdminModalStyles = {
  overlay: css`
    label: SUPER_ADMIN_MODAL_OVERLAY;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${SETTINGS_SCRIM_COLOR};
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 2000;
    padding: ${SETTINGS_SPACING.gutterX}px;

    @media (max-width: 1024px) {
      padding: 12px;
    }
  `,
  content: css`
    label: SUPER_ADMIN_MODAL_CONTENT;
    background: ${SETTINGS_COLORS.pageBackground};
    border: 1px solid ${SETTINGS_COLORS.border};
    border-radius: 3px;
    width: min(1200px, calc(100vw - 120px));
    max-height: calc(100vh - 40px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    @media (max-width: 1024px) {
      width: calc(100vw - 24px);
      max-height: calc(100vh - 24px);
    }
  `,
  header: css`
    label: SUPER_ADMIN_MODAL_HEADER;
    padding: 14px ${SETTINGS_SPACING.gutterX}px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${SETTINGS_SPACING.gutterX}px;
    background: ${SETTINGS_COLORS.white};
    border-bottom: 1px solid ${SETTINGS_COLORS.border};
    position: sticky;
    top: 0;
    z-index: 1;
  `,
  title: css`
    label: SUPER_ADMIN_MODAL_TITLE;
    ${SETTINGS_TITLE_REGULAR_STYLE}
  `,
  body: css`
    label: SUPER_ADMIN_MODAL_BODY;
    padding: 0 0 ${SETTINGS_SPACING.standardPadding}px;
  `,
  closeButton: {
    minHeight: 32,
    padding: '0 16px',
    border: `1px solid ${SETTINGS_COLORS.border}`,
    borderRadius: 5,
    background: SETTINGS_COLORS.white,
    color: SETTINGS_COLORS.text,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    fontFamily: 'CircularXX, sans-serif',
    fontSize: pxToRem(12),
    fontWeight: 700,
    lineHeight: 1.167,
    letterSpacing: '0.24px',
    cursor: 'pointer',
  },
};
